/**
 * Bestellungen.
 *
 * ===================== Die Form des Schreibkanals - GEMESSEN, nicht angenommen =====================
 *
 * Bis Task 5a stand hier "DIE GENAUE FORM DIESES ENDPUNKTS STEHT ERST MIT PHASE 4a FEST" und
 * `bestellungAendern` war `ressource().aendern`, also `PUT /api/orders/:id` mit flachem Koerper.
 * DIESE ROUTE GIBT ES IM BACKEND NICHT (`backend/src/http/endpunktMatrix.ts:50-70`; die einzige
 * PUT-Route unter /api/orders ist `/:id/item-order`, `backend/src/http/routes/orders.ts:380`).
 * Aufgefallen ist das erst im Review zu Task 5, weil `bestellungAendern` in jedem Verdrahtungstest
 * eine Attrappe ist: die Tests pruefen, DASS sie gerufen wird und WOMIT - nie, ob es die Route gibt.
 *
 * Die tatsaechliche Form, Zeile fuer Zeile nachgeschlagen:
 *
 *   Geschrieben wird ueber `PATCH /api/orders/:id/<gruppe>` mit `{ rowVersion, felder }`
 *     -> `backend/src/http/routes/orders.ts:212-250` (fuenf Routen, EIN `feldgruppenHandler`)
 *   Jede Gruppe traegt eine EIGENE Berechtigung: edit_orders, manage_costs, manage_payments,
 *   request_payment, manage_fx
 *     -> `endpunktMatrix.ts:54-58`
 *   Der Koerper traegt snake_case-Schluessel, die ANTWORT camelCase - die Naht ist asymmetrisch
 *     -> Schreibprobe `felder: { container_type: "20" }` in
 *        `backend/test/integration/domaene-dsv-sperre.test.ts:27-33`; die Antwort laeuft durch
 *        `oeffentlich()` (`backend/src/domaene/oeffentlich.ts`), das mechanisch snake->camel setzt
 *   Ein Schluessel, der nicht zur Gruppe gehoert, wird VOR jedem Schreibvorgang abgewiesen -
 *   kein Teilschreiben
 *     -> `orders.ts:137-142`, `schreibeExtras` in `backend/src/domaene/extras.ts:46-51`
 *
 * WARUM DAS SO BLEIBT UND NICHT ZU EINEM GEMEINSAMEN PUT ZUSAMMENGEZOGEN WIRD: die Aufteilung IST
 * das Rechtemodell. Der Bestand ordnete Bestellfelder ueber `permissionForOrderField()`
 * (cloudflare/src/worker.ts:696) fuenf Berechtigungen zu; die Spec ersetzt "Berechtigung -> Feld"
 * durch "Berechtigung -> Endpunkt" (siehe Kopfkommentar von `backend/src/domaene/feldgruppen.ts`).
 * Ein gemeinsames `PUT /api/orders/:id` gaebe es nicht nur nicht - es wuerde die Aufteilung
 * aushebeln. Die SPA passt sich an, das Backend wird nicht angefasst.
 *
 * DIE ANTWORT AUF EIN PATCH IST NICHT DIE BESTELLUNG. `feldgruppenHandler` antwortet mit
 * `oeffentlich(zeile)` ueber die `order_extras`-ZEILE (`orders.ts:146`) - die traegt weder `id` noch
 * `orderNo` noch die Felder der `orders`-Tabelle. Wuerde `bestellungAendern` sie zurueckgeben,
 * schriebe der Aufrufer (`App.tsx#drawerAendern` -> `versende({ art: "nachgeladen", datensatz })`)
 * einen Rumpfdatensatz in den Store. Deshalb laedt diese Datei nach dem Schreiben nach - dasselbe
 * Muster, das `App.tsx#drawerDokumentHochladen` fuer den Upload schon benutzt
 * (`dokumentHochladen(...).then(() => bestellungLaden(...))`), weil auch `documents.ts` nur
 * `{ document, version, file }` liefert.
 *
 * ===================== EREIGNISNAME UND PFAD SIND ZWEI DINGE (Fix-Runde 1 zu Task 5a) ============
 *
 * Bis zu dieser Runde stand hier: der Pfad ist `/api/orders`, ABGELEITET aus dem SSE-Entitaetsnamen
 * `"orders"`, denn das Backend beschreibe `entity` als "die vom Client aufrufbare REST-Route" -
 * beide MUESSTEN also zusammenfallen. Nachgemessen fallen sie NICHT zusammen:
 *
 *   Ereignisname `"order"` (Einzahl)  -> `backend/src/http/routes/orders.ts:152,204,290,371,410,452`
 *                                        und `BROADCAST_ENTITIES` in `backend/src/sse/broadcast.ts`
 *   REST-Pfad    `/api/orders`        -> `backend/src/http/endpunktMatrix.ts:50-70`
 *
 * Die Folge der Ableitung war kein Schoenheitsfehler: `state/Speicher.tsx` schlaegt den Nachlader
 * unter dem Ereignisnamen nach, der aus dem Ereignis kommt (`"order"`), fand aber nur den Schluessel
 * `"orders"` - JEDES eingehende Ereignis lief in "Kein Nachlader fuer Entitaet …", die gesamte
 * Mehrbenutzer-Aktualisierung war tot. Aufgefallen ist es nicht, weil beide Seiten je gegen ihre
 * EIGENE Attrappe gruen waren.
 *
 * Deshalb stehen hier ab jetzt ZWEI benannte Konstanten und keine Rechnung. Dass sie zum Backend
 * passen, prueft `test/komponenten/api/entitaeten.test.ts` (RIEGEL 3) gegen die Backend-DATEIEN,
 * nicht gegen ein Textabbild davon.
 *
 * ===================== DIE ANTWORT IST VERSCHACHTELT, DIE SPA LIEST FLACH ========================
 *
 * `GET /api/orders/:id` antwortet mit `{ ...orders-Zeile, extras: { …order_extras… }, supplier }`
 * (`backend/src/domaene/orders.ts:145-149`). Die SPA liest `etd`, `eta`, `container_type`, …
 * ausnahmslos FLACH - kein einziger Lesezugriff auf `.extras` ausserhalb dieses Ordners.
 * RICHTIGGESTELLT (Auftrag E): `notes` und `warehouse` standen in dieser Aufzaehlung bis Auftrag D
 * (2026-08-22, `backend/migrations/017_order_extras_warehouse_notes_entfernen.sql`) - beide Spalten
 * sind entfernt und tauchen deshalb hier nicht mehr auf. Ohne Aufloesung traegt der Store nach jedem
 * Schreibvorgang (der seit Task 5a immer nachlaedt) einen Datensatz, dessen Extras eine Ebene tiefer
 * liegen: Drawer und Board zeigen sie leer.
 *
 * `entschachtele()` unten loest das an der Naht auf - derselbe Ort, an dem die Drahtform ohnehin
 * uebersetzt wird.
 */
import { ApiFehler, anfrage, ressource } from "./basis.ts";
import { jtlBestellungLaden, nummerAusAbgeleiteterKennung, zusammenfuehren } from "./jtlBestellungen.ts";
import { entschachtele } from "../lib/bestellungDraht.ts";
import type { Order } from "../lib/types.ts";

// `entschachtele` samt seinen Helfern (`supplierIdVonKopf`, `supplierNameVonKopf`) und den Nahtfunktionen
// `alsAufgabe`/`alsRate` wohnt seit dem KI-Zugang (Stufe 1) in `lib/bestellungDraht.ts`, weil der Server
// dieselbe Umformung fahren muss. Der Name bleibt hier erreichbar; die Kopfkommentare zur Drahtform
// (oben, `api/aufgaben.ts`) gelten unveraendert.
export { entschachtele };

/**
 * Name dieser Entitaet im SSE-Ereignis (`event.entity`) - EINZAHL. Gemessen an
 * `backend/src/http/routes/orders.ts:152` (und fuenf weiteren Broadcasts derselben Datei); die
 * Allowlist dazu ist `BROADCAST_ENTITIES` in `backend/src/sse/broadcast.ts`.
 *
 * NICHT der Pfad - siehe `BASISPFAD` und den Kopfkommentar.
 */
export const SSE_ENTITAET = "order";

/**
 * REST-Basispfad dieser Entitaet - MEHRZAHL. Gemessen an `backend/src/http/endpunktMatrix.ts:50`
 * (`GET /api/orders`). Steht hier als Literal und wird NICHT aus `SSE_ENTITAET` errechnet: die
 * beiden Namen haben verschiedene Quellen im Backend und fallen nachweislich auseinander.
 */
export const BASISPFAD = "/api/orders";

const zugriff = ressource<Order>(BASISPFAD);

/**
 * `GET /api/orders`. Bis zur Fix-Runde 1 war das `zugriff.liste` selbst; jetzt laeuft jeder
 * Datensatz durch `entschachtele()` - nicht weil diese Route heute etwas verschachteltes lieferte
 * (sie liefert `SELECT * FROM orders`, also gar keine Zusatzfelder), sondern damit BEIDE Lesewege
 * dieselbe Form in den Store geben. Sonst haenge die Form davon ab, ueber welchen der beiden ein
 * Datensatz zuletzt hereinkam.
 *
 * BEFUND, GEMELDET UND NICHT REPARIERT: diese Route liefert weder `name` noch `etd`/`eta`/`notes`
 * noch `boardGroupOverride` - `ladeBestellungen` liest ausschliesslich die `orders`-Tabelle
 * (`backend/src/domaene/orders.ts:152-155`), und dort steht nur der JTL-Bezug. Der Anfangsbestand
 * ueber die Domaenenrouten (`state/Speicher.tsx#bestandLaden`, Zweig 2) traegt damit Bestellungen
 * ohne jedes Anzeigefeld. Das ist eine Luecke im BACKEND und in dieser Runde nicht zu schliessen
 * (das Backend wird nicht veraendert).
 */
export async function bestellungenLaden(signal?: AbortSignal): Promise<Order[]> {
  return (await zugriff.liste(signal)).map((eintrag) => entschachtele(eintrag));
}

/**
 * `GET /api/orders/:id` - die verschachtelte Antwort, flach gemacht (siehe `entschachtele`), UND
 * seit dem 2026-08-15 mit der JTL-Bestellung angereichert.
 *
 * ================= WARUM DIE ANREICHERUNG HIERHIN GEHOERT UND NICHT ZUM AUFRUFER ================
 *
 * Seit `60b076e` gilt: "die Bestellungen kommen aus JTL, der Hub reichert an". Das war aber nur im
 * ANFANGSBESTAND wahr (`state/Speicher.tsx#bestandLaden` -> `jtlBestellungenRohLaden` +
 * `lib/bestandZusammensetzen.ts#bestellungenZusammensetzen`). Diese Funktion
 * hier ist der EINZIGE Nachladeweg - sie bedient den SSE-Nachlader (`NACHLADER` in `Speicher.tsx`),
 * `bestellungAendern` unten, den Dokumenten-Upload und die drei Aufgabenwege in `App.tsx`. Sie
 * lieferte die reine Hub-Zeile, und weil der Reduzierer beim Nachladen VOLLSTAENDIG ersetzt, verlor
 * die Bestellung nach jedem Schreibvorgang ihre JTL-Felder: Bestellnummer weg, Bestellwert 0,
 * EK-Tabelle leer. Die vollstaendige Liste der betroffenen Felder steht bei `jtlBestellungLaden`
 * (`api/jtlBestellungen.ts`).
 *
 * Die Anreicherung an die vier Aufrufstellen zu haengen waere dieselbe Regel an vier Orten - und
 * genau die Bauform, an der dieses Projekt schon mehrfach auseinandergelaufen ist. Sie steht deshalb
 * an der einen Naht, durch die alle vier laufen, direkt neben `entschachtele`, das hier ohnehin die
 * Drahtform in die Speicherform setzt.
 *
 * ================= EIN AUSFALL VON JTL LEHNT AB, STATT EINE HALBE ZEILE ZU LIEFERN ===========
 *
 * Scheitert die JTL-Abfrage, lehnt diese Funktion mit der URSACHE ab (Fehleranzeige Paket 2, Entscheidung E2).
 * Bis dahin lieferte sie die HUB-ZEILE ohne JTL-Felder (Bestellnummer weg, Bestellwert 0, EK-Tabelle leer), mit
 * der Begruendung, der Schreibvorgang sei ja schon geschehen. Das stimmt, aber die halbe Zeile ist trotzdem
 * schlimmer als eine Meldung: der Reduzierer ersetzt beim Nachladen den ganzen Datensatz, eine halbe Zeile
 * verdraengt also die volle, und niemand sieht es. Der Schreibvorgang wird dadurch nicht zum Fehlschlag - jeder
 * Aufrufer hat einen Fehlerweg, der "gespeichert, Anzeige nicht aktuell" sagt: das Live-Nachladen
 * (`state/Speicher.tsx`, L4), `nachladen` unten (`NachladenNachSchreibenFehler`), die R4-Wege der Drawer-Haken
 * und die Aufloesung einer Adresse (`components/App/bestellungsAufloesung.ts`). Der Store behaelt seine volle Zeile.
 *
 * OHNE `jtlOrderId` UND ohne abgeleitete Kennung gibt es nichts anzureichern (eine Bestellung, die nur im Hub steht -
 * der Entwurf vor dem ersten JTL-Schreibvorgang, `id` eine UUID). Dann faellt die zweite Anfrage ganz aus.
 *
 * ================= BESTELLUNG OHNE HUB-ZEILE: DIE NUMMER STEHT IN DER KENNUNG =================
 *
 * Fehleranzeige Paket 2, Task 7b (Ruling R-T7b). Der Regelfall ist eine Bestellung OHNE Hub-Overlay (die Zeile steht im
 * Store unter `jtl-<n>`, siehe `abgeleiteteKennung`). Fuer sie antwortet `GET /api/orders/jtl-<n>` mit `200 {}`
 * (`backend/src/http/routes/orders.ts`, `loeseKennungZumLesenAuf` legt nie an), also OHNE `jtlOrderId`. Ohne diesen Zweig
 * kam `{}` zurueck, und der Reduzierer ersetzt beim Nachladen den ganzen Datensatz: die volle Zeile unter `jtl-<n>` wurde
 * zu `{}` - der Fehler, den E2 ausschliessen soll ("nie ersetzt eine halbe Zeile eine volle"). Erreichbar ueber das
 * Konflikt-Banner "neu laden" nach einem 409 des JTL-Schreibwegs und ueber die Stummelantwort nach einem gelungenen
 * JTL-Schreiben.
 *
 * Fehlt die `jtlOrderId` und ist `id` eine abgeleitete Kennung, kommt die Nummer deshalb aus der Kennung
 * (`nummerAusAbgeleiteterKennung`), und die Anreicherung laeuft wie gewohnt; die `{}` des Hubs gilt dabei als "kein Hub"
 * (`zusammenfuehren`). Scheitert die JTL-Anfrage, lehnt die Funktion mit der Ursache ab (E2). Antwortet JTL mit 404 (die
 * Bestellung gibt es dort nicht oder sie ist geloescht), gibt es die Bestellung nicht: `null`, wie bei einer fehlenden
 * Hub-Zeile - ohne diesen Fall wuerde der Store sie ueber die Ablehnung nie los.
 */
export async function bestellungLaden(
  id: string,
  signal?: AbortSignal,
  // Nur der SSE-Nachlader (`state/Speicher.tsx`, `NACHLADER`) setzt das: beide Anfragen dieser Kette
  // (Hub-Zeile, JTL-Bestellung) gehen dann als automatische Anfragen hinaus (`AnfrageOptionen.hintergrund`).
  hintergrund?: boolean,
): Promise<Order | null> {
  const hub = await hubZeileLaden(id, signal, hintergrund);
  if (hub === null) return null;
  const jtlNummer = Number((hub as { jtlOrderId?: unknown }).jtlOrderId);
  if (Number.isSafeInteger(jtlNummer) && jtlNummer > 0) {
    return zusammenfuehren(await jtlBestellungLaden(jtlNummer, signal, hintergrund), hub);
  }
  const nummerAusKennung = nummerAusAbgeleiteterKennung(id);
  if (nummerAusKennung === null) return hub;
  try {
    return zusammenfuehren(await jtlBestellungLaden(nummerAusKennung, signal, hintergrund), hub);
  } catch (fehler) {
    if (fehler instanceof ApiFehler && fehler.status === 404) return null;
    throw fehler;
  }
}

/**
 * Nur die Hub-Zeile zu `id` (roh, geflacht ueber `entschachtele`) - OHNE die JTL-Anreicherung, die
 * `bestellungLaden` oben zusaetzlich vornimmt. Aus `bestellungLaden` HERAUSGEZOGEN (Befund K2/K3,
 * Nachbesserung Runde 3, "Serverseitiger Archivfilter + Ladeanzeige"): `App.tsx
 * #bestellungNachKennungNachladen` hat die passende JTL-Bestellung beim Aufloesen einer eigenen
 * Bestellnummer bereits SELBST geladen - ein zweiter, hier redundanter JTL-Rundlauf wie in
 * `bestellungLaden` waere unnoetig, sie braucht nur noch die Hub-Zeile dazu, um GENAU WIE der
 * Listenlauf (`state/Speicher.tsx#bestandLaden`: `jtlBestellungenRohLaden`, danach
 * `lib/bestandZusammensetzen.ts#bestellungenZusammensetzen`) selbst `zusammenfuehren(jtl, hub)` zu
 * bilden. `bestellungLaden` ruft diese Funktion ebenfalls - EIN Ort, der `GET /api/orders/:id` liest
 * und flach macht, statt einer zweiten Kopie derselben zwei Zeilen.
 *
 * `null`: die Anfrage selbst ist gescheitert (Netz, 404 - siehe `ressource().einzeln`/
 * `anfrageOderNull`). `{}` (kein Overlay zu dieser Bestellung, der HAEUFIGE Normalfall - siehe
 * `backend/src/http/routes/orders.ts`, "leerer Normalfall statt 404") kommt dagegen unveraendert als
 * flaches, faktisch leeres Objekt zurueck, ERKENNBAR AN `hub.id === undefined` (die Route liefert
 * `id` nur MIT einer echten `orders`-Zeile) - `zusammenfuehren(jtl, hub)` behandelt das identisch zu
 * `zusammenfuehren(jtl, undefined)` (siehe dessen Kopfkommentar, `id: hub?.id ?? abgeleiteteKennung(...)`).
 */
export async function hubZeileLaden(
  id: string,
  signal?: AbortSignal,
  hintergrund?: boolean,
): Promise<Order | null> {
  const datensatz = await zugriff.einzeln(id, signal, hintergrund);
  if (datensatz === null) return null;
  return entschachtele(datensatz) as Order;
}

/**
 * Die Anlage ist der einzige Weg, der den Lieferantenstandard anwenden darf. Der Server liefert
 * dabei den fertigen Zahlungs-Snapshot bereits mit; dieselbe Naht wie bei Einzelabrufen flacht ihn
 * fuer den Store ab.
 */
export function bestellungAnlegen(eingabe: Partial<Order>): Promise<Order> {
  return zugriff.anlegen({ ...eingabe, applySupplierDefault: true }).then((antwort) => entschachtele(antwort));
}
export const bestellungLoeschen = zugriff.loeschen;

/** Die fuenf berechtigungsgebundenen Teilressourcen derselben `order_extras`-Zeile. */
export type Feldgruppe = "extras" | "costs" | "payment-state" | "payment-request" | "fx-fields";

/**
 * Die Spalten je Gruppe, in snake_case - die Zweitschrift von
 * `backend/src/domaene/feldgruppen.ts#FELDGRUPPEN`.
 *
 * Sie steht bewusst in snake_case und nicht in camelCase: so ist sie Zeichen fuer Zeichen mit der
 * Quelle vergleichbar, und der Abgleichtest (RIEGEL 1, `test/komponenten/api/bestellungen.test.ts`)
 * kann die Backend-Datei laden und beide Tabellen Feld fuer Feld gegeneinanderhalten, statt eine
 * Namensumformung mitpruefen zu muessen. Die camelCase-Namen, unter denen die SPA dieselben Felder
 * kennt, werden unten MECHANISCH daraus abgeleitet (`alsCamel`) - eine zweite, von Hand gepflegte
 * Namensliste gaebe es sonst, und die koennte still danebenlaufen.
 *
 * Die Zweitschrift darf existieren - sie darf nur nicht STILL driften. Dieselbe Bauform benutzt das
 * Projekt fuer `backend/test/endpunkt-matrix-spec-abgleich.test.ts`.
 */
export const FELDGRUPPEN_SPALTEN: Readonly<Record<Feldgruppe, readonly string[]>> = Object.freeze({
  extras: Object.freeze([
    // warehouse UND notes standen bis Auftrag D (2026-08-22) hier - beide Spalten sind entfernt
    // (backend/migrations/017_order_extras_warehouse_notes_entfernen.sql), Begruendung im
    // Kopfkommentar von backend/src/domaene/feldgruppen.ts.
    //
    // order_date stand bis Auftrag "Bestellfelder nach Anlage sperren" (2026-08-25) hier - seither
    // NICHT_SCHREIBBAR (Begruendung dort): es wird bei der Anlage einmalig gesetzt, ist danach
    // unveraenderlich und wird bei verknuepfter JTL-Bestellung zusaetzlich live aus JTL ueberschrieben.
    //
    // delivery_term_text stand kurzzeitig ebenfalls in NICHT_SCHREIBBAR (selber Auftrag), dann wieder
    // hier (Nachtrag 2, 2026-08-25, einmalig schreibbar) - mit Auftrag "Liefertermin auf echtes
    // JTL-Feld umstellen" (2026-08-26) ist die Spalte GAR NICHT mehr Teil von order_extras (Migration
    // 024): der Liefertermin-Freitext kommt seither ausschliesslich aus JTL (cDruckAnmerkung),
    // genau wie Lieferant und Lager.
    "etd", "eta", "etd_pi", "eta_booking_offset_days", "estimated_delivery_buchen",
    "container_type", "container_volume",
    "eka_received_date", "eka_booking_date", "eka_received_date_confirmed",
    "eka_received_date_confirmed_by", "eka_received_date_confirmed_at",
    "pi_no", "invoice_no",
    "board_group_override", "archived", "image", "custom_fields",
    "list_due_date", "name",
    "raw_material",
    // Task 4 (Plan 2026-08-17-bestellexcel-anlagemaske): der Bestellexcel-Auswertungssatz - Zweitschrift
    // von `backend/src/domaene/feldgruppen.ts`, Grund fuer die Verschiebung aus NICHT_SCHREIBBAR steht
    // dort.
    "order_excel_import",
    // Zweitschrift zu backend/src/domaene/feldgruppen.ts - Feature "See/Flug-Umschaltung"
    // (Spec 2026-08-26-spedition-see-flug-design.md, E2).
    "transport_mode", "air_carrier", "air_awb_no", "air_status",
    // Zweitschrift zu backend/src/domaene/feldgruppen.ts - Auftrag "Manueller 3-Stufen-Zeitstrahl
    // fuer Flug-Sendungen" (2026-08-27, migrations/029_air_zeitstrahl_stufen.sql).
    "air_etd", "air_eta", "air_absina",
    // Zweitschrift zu backend/src/domaene/feldgruppen.ts - Asana "Zusaetzlicher LKW Speditionstyp"
    // (1218176179911324): dritte Transportart "road", reine Handpflege wie "air".
    "road_carrier", "road_cmr_no", "road_status", "road_etd", "road_eta",
    // Zweitschrift zu backend/src/domaene/feldgruppen.ts - Auftrag "Stock Order / Liefertermine
    // fixiert" (migrations/052_order_extras_liquiditaet_felder.sql).
    "stock_order", "transport_dates_fixed",
  ]),
  costs: Object.freeze([
    "duty_pct", "duty_pct_locked", "tooling_cost", "freight", "freight_fees",
    "freight_invoice", "customs_invoice", "supplier_invoice", "order_value_override",
  ]),
  "payment-state": Object.freeze([
    "payment_mail_prepared_at", "payment_mail_prepared_by", "paid", "paid_date",
  ]),
  "payment-request": Object.freeze(["payment_initiated_at", "payment_initiated_by"]),
  "fx-fields": Object.freeze([
    "supplier_credit", "credit_currency", "raw_material_rate", "raw_material_currency",
  ]),
});

/**
 * `board_group_override` -> `boardGroupOverride`. Genau die Umformung, die `oeffentlich()` macht.
 *
 * EXPORTIERT seit der Fix-Runde 1, allein damit RIEGEL 1b sie gegen das Original halten kann:
 * `camelSchluessel` in `backend/src/domaene/oeffentlich.ts` ist die Quelle, diese Funktion die
 * Zweitschrift. Riegel 1 vergleicht nur die snake_case-LISTEN, nicht die Umformung - eine Drift
 * hier (etwa `_([a-z])` statt `_([a-z0-9])`, was `eta_booking_offset_days` unberuehrt liesse, aber
 * jede Spalte mit einer Ziffer hinter dem Unterstrich falsch umsetzte) bliebe davon unbemerkt.
 */
export function alsCamel(spalte: string): string {
  return spalte.replace(/_([a-z0-9])/g, (_treffer, zeichen: string) => zeichen.toUpperCase());
}

/**
 * camelCase-Feldname -> Gruppe und snake_case-Spalte. Eine `Map`, kein Objektliteral: der Schluessel
 * kommt aus einem Aenderungsobjekt, also aus Daten - ein Objekt-Lookup damit greift bei
 * `"constructor"`/`"__proto__"` auf `Object.prototype` durch und liefert einen wahrheitswertigen
 * Treffer, wo keiner ist. Dasselbe Fehlermuster hat das Projekt mehrfach beschaeftigt (siehe
 * `ENTITAET_ZU_FELD` in `state/reduzierer.ts` und `spaltenDerGruppe` im Backend).
 *
 * Der Doppeltreffer-Wurf ist kein Zierrat: er laeuft beim Laden des Moduls und faengt einen
 * Uebertragungsfehler, bei dem dieselbe Spalte in zwei Gruppen landet - eine der beiden Gruppen
 * wuerde sonst je nach Reihenfolge stillschweigend gewinnen.
 */
const GRUPPE_JE_FELD: ReadonlyMap<string, { gruppe: Feldgruppe; spalte: string }> = (() => {
  const karte = new Map<string, { gruppe: Feldgruppe; spalte: string }>();
  for (const gruppe of Object.keys(FELDGRUPPEN_SPALTEN) as Feldgruppe[]) {
    for (const spalte of FELDGRUPPEN_SPALTEN[gruppe]) {
      const feld = alsCamel(spalte);
      const vorher = karte.get(feld);
      if (vorher) {
        throw new Error(
          `bestellungen: "${spalte}" steht in zwei Gruppen ("${vorher.gruppe}" und "${gruppe}").`,
        );
      }
      karte.set(feld, { gruppe, spalte });
    }
  }
  return karte;
})();

/**
 * Felder, die die SPA schreibt oder geschrieben hat, die aber KEINE Feldgruppe hat - mit dem gemessenen
 * Grund und, wo es einen gibt, dem richtigen Weg. `usdRate` wird seit der Kurs-Sperre vom 2026-09-07
 * nur noch gelesen (`readOnly`, kein `onChange`); fuer `fxNone` und `pdfs` gibt es seit Ticket H
 * (2026-10-20) keinen Schreiber mehr in der Oberflaeche. Die Eintraege bleiben als Begruendung stehen
 * (und weil `bundle.test.ts` Laenge und Namen prueft). Diese Tabelle macht das laute Scheitern (RIEGEL 2)
 * benutzbar: ohne sie stuende in der Meldung nur "kennt das Feld nicht", und der naechste Leser muesste die
 * Suche von vorn beginnen, die uns diesen Task gekostet hat.
 *
 * Sie ist KEINE Erlaubnisliste - jedes Feld hier wirft genauso wie ein Tippfehler.
 *
 * EXPORTIERT seit dem Gesamtreview 2026-08-11 (Important 9), und das ist keine Bequemlichkeit:
 * bis dahin war die Tabelle MODULPRIVAT, und damit konnte KEIN Test sie lesen oder ihre Laenge
 * zaehlen. Gemessen war der Stand: siebzehn Eintraege, von denen `test/komponenten/api/
 * bestellungen.test.ts` genau FUENF namentlich absicherte - die uebrigen zwoelf hatten nirgends
 * eine Zusicherung, und in `test/reference/bundle.test.ts` war die Klasse ueberhaupt nicht
 * registriert. Faellt ein Eintrag heraus, degradiert `FeldOhneGruppeFehler` LAUTLOS auf den blossen
 * Feldnamen - genau die Sackgasse, gegen die diese Tabelle laut ihrem eigenen Kopfsatz oben gebaut
 * wurde. Seit dieser Runde prueft `bundle.test.ts` Laenge UND jeden Namen einzeln, nach dem Muster
 * der `NEGATIVLISTE` dort.
 *
 * `ReadonlyMap` und keine `Map`: der Export gibt Lesezugriff, keinen Schreibzugriff. Die Ordnung
 * der Eintraege ist bedeutungslos - `bundle.test.ts` vergleicht deshalb ueber eine Menge, nicht
 * ueber eine Reihenfolge.
 */
export const KEIN_FELDGRUPPEN_WEG: ReadonlyMap<string, string> = new Map([
  [
    "tasks",
    "eigene Tabelle order_tasks; Weg: aufgabeAendern() in api/aufgaben.ts " +
      "(PATCH /api/orders/:id/tasks/:taskId) - JE AUFGABE, nicht als ganzes Array. Bis 2026-08-11 " +
      "fehlte dafuer die rowVersion je Aufgabe; seither liefert GET /api/orders/:id sie flach mit " +
      "(orders.ts#ladeBestellung), und components/App/App.tsx#drawerAufgabeAendern ruft " +
      "aufgabeAendern seit 2026-08-15 tatsaechlich mit dieser rowVersion auf - der alte Grund ist " +
      "entfallen (Beleg: test/reference/bundle.test.ts, Kommentar ueber UNTERRESSOURCEN_API, " +
      "Kategorie F)",
  ],
  [
    "payments",
    "eigene Tabelle order_payment_schedule; Weg: ratenAendern() in api/zahlungsraten.ts " +
      "(PATCH /api/orders/:id/payments/:payId) - JE RATE, nicht als ganzes Array. Die rowVersion " +
      "kommt seit 2026-08-11 mit: zahlungen.ts#ladeRatenJeBestellung liest SELECT * und " +
      "oeffentlich() setzt row_version -> rowVersion, orders.ts#ladeBestellung reicht die Zeilen " +
      "unveraendert durch. Der alte Grund (\"fehlt heute die rowVersion je Rate\") ist damit " +
      "entfallen - geschrieben wurde trotzdem das GANZE Array, solange " +
      "Drawer/PaymentTab/ZahlungTab.tsx nur das bestellungsweite onAendern kannte (Beleg: " +
      "test/reference/bundle.test.ts, Kommentar ueber UNTERRESSOURCEN_API, Kategorie F). Seit Task 7 " +
      "(Zahlungsraten-Reparatur) laeuft jede Rate ueber onRatenSynchronisieren, kein Aufrufer in src " +
      "schreibt payments mehr ueber onAendern",
  ],
  [
    "pdfs",
    "eigene Tabelle order_documents; Hochladen: dokumentHochladen() in api/dokumente.ts. " +
      "Entfernen: dokumentEntfernen() in api/dokumente.ts (DELETE /api/orders/:id/document-links/" +
      ":linkId, seit Spec 2026-10-16; DocsTab/DokumenteTab.tsx#loeschen) - ein Schreibzugriff auf " +
      "pdfs bleibt trotzdem ohne Feldgruppe. Den letzten Schreiber, den Beleg-Papierkorb im Zahlungs-Reiter " +
      "(App.tsx#drawerBelegLoeschen), gibt es seit Ticket H (2026-10-20) nicht mehr.",
  ],
  [
    "boardStatus",
    "eigener Endpunkt mit Verlaufseintrag (NICHT_SCHREIBBAR in feldgruppen.ts); " +
      "Weg: boardStatusAendern() in diesem Modul",
  ],
  [
    "items",
    "eigene Tabelle order_item_extras; Weg: positionAendern() in api/positionen.ts " +
      "(PATCH /api/orders/:id/items/:jtlPosId) - JE POSITION, nicht als ganzes Array",
  ],
  ["docsManual", "NICHT_SCHREIBBAR (feldgruppen.ts): order_documents.status gewinnt (U5)"],
  ["docsNa", "NICHT_SCHREIBBAR (feldgruppen.ts): order_documents.status gewinnt (U5)"],
  [
    "piImport",
    "NICHT_SCHREIBBAR (feldgruppen.ts): Ergebnis der OCR-Auswertung, geschrieben vom Importpfad",
  ],
  // orderExcelImport stand hier bis Task 4 (Plan 2026-08-17-bestellexcel-anlagemaske) - es liegt seither
  // in FELDGRUPPEN_SPALTEN.extras (Grund in backend/src/domaene/feldgruppen.ts) und geht ueber
  // `bestellungAendern` denselben Weg wie jedes andere extras-Feld.
  // ---------------------------------------------------------------------------------------------
  // Fix-Runde 1 (Minor 1): die acht Felder, die die SPA damals schrieb (heute nicht mehr alle, siehe Kopfsatz
  // der Tabelle), ohne dass es sie in order_extras ueberhaupt gibt. Bis hierher warfen sie mit blossem
  // Feldnamen - der naechste Leser haette die Suche neu beginnen muessen, die dieser Task schon einmal
  // gekostet hat. Jeder Grund ist am BACKEND nachgeschlagen, nicht geraten:
  // `backend/src/migration/altbestand/feldinventar.ts` fuehrt fuer jedes Altfeld Klasse, Ziel und Begruendung.
  // ---------------------------------------------------------------------------------------------
  [
    "orderNo",
    "gehoert JTL (feldinventar.ts:35, Klasse \"jtl\"): cEigeneBestellnummer wird beim Speichern von " +
      "JTL vergeben und nur zurueckgelesen (Spec 592-602). Das Tool schickt sie NIE mit",
  ],
  // ---------------------------------------------------------------------------------------------
  // 2026-08-15: die zwei Felder, an denen die letzten beiden benannten Luecken des Reiters
  // „Bestellung" haengen (`onLieferant`, `onTracking`). Beide fehlten hier - ein Schreibversuch warf
  // also mit BLOSSEM Feldnamen, und der naechste Leser haette dieselbe Suche noch einmal gemacht,
  // gegen die diese Tabelle laut ihrem Kopfsatz gebaut ist. Gegen `feldinventar.ts` nachgeschlagen,
  // nicht geraten.
  // ---------------------------------------------------------------------------------------------
  [
    "supplier",
    "gehoert JTL: der Lieferant haengt als kLieferant am Bestellkopf und wird nur zurueckgelesen " +
      "(api/bestellungen.ts#supplierIdVonKopf). Ausserdem ist ein Wechsel mehr als ein Feld - " +
      "setSupplier (index.html:9906) uebernimmt Zahlungsziel und Ratenplan aus den " +
      "Lieferantenstammdaten und legt Zahlungen an; Weg waere ein eigener Kanal (onLieferant), " +
      "den es heute nicht gibt",
  ],
  [
    "trackingNo",
    "entfaellt im neuen Modell (feldinventar.ts:114, Klasse \"postgres\"): die Trackingnummer WIRD " +
      "eine Sendung (shipments.dsv_shipment_no + order_shipments, Spec 134/1053) - eine Spalte am " +
      "Bestellkopf gibt es dafuer nicht mehr. Dasselbe gilt fuer trackingLockedAt/trackingLockedBy",
  ],
  [
    "taskPhaseDetails",
    "eigene Tabelle order_task_phase_details (feldinventar.ts:106; migrations/005_domaene.sql:185). " +
      "Es gibt dafuer bis heute KEINE Route - kein Treffer fuer phase_details in backend/src/http",
  ],
  [
    "forwarderUrl",
    "Sendungsmerkmal, nicht Bestellfeld: shipments.portal_url (feldinventar.ts:115, Spec 1052). " +
      "Geschrieben wird die Spalte ausschliesslich vom DSV-Abgleich " +
      "(backend/src/http/routes/dsvShipments.ts:175-221), nicht von Hand",
  ],
  [
    "usdRate",
    "gehoert zur RATE, nicht zur Bestellung: order_payment_schedule.usd_rate (feldinventar.ts:58); " +
      "Weg waere ratenAendern() in api/zahlungsraten.ts (PATCH /api/orders/:id/payments/:payId) - " +
      "je Rate, mit rowVersion, die seit 2026-08-11 mitkommt (siehe Eintrag \"payments\" oben). " +
      "Das Bedienelement \"Manueller Dollarkurs\" (frueher Drawer/PaymentTab/ZahlungTab.tsx#patch: " +
      "onAendern(id, { usdRate })) schrieb ein FLACHES Kopffeld, fuer das es im neuen Modell keine " +
      "Kopfspalte gibt - der Wert gehoert zur Rate, nicht zum Kopf; das Feld ist seit Ticket H " +
      "(2026-10-20) aus dem Zahlungs-Reiter entfernt",
  ],
  [
    "mixedUsdRate",
    "VERWORFEN (feldinventar.ts:120): der Mischkurs wird aus fx_deals + fx_allocations gerechnet " +
      "(Spec 203) - ein gespeicherter Wert koennte veralten. Es gibt keine Spalte dafuer",
  ],
  [
    "paymentMode",
    "VERWORFEN (feldinventar.ts:121): aus den Raten ableitbar (inferPaymentMode); " +
      "order_payment_schedule kennt beliebig viele Raten und braucht den Modus nicht",
  ],
  [
    "fxNone",
    "OFFENER BEFUND (feldinventar.ts:130): \"keine Kurssicherung gewuenscht\" ist ohne das Flag " +
      "nicht von \"noch nicht zugeordnet\" zu unterscheiden. Der Altwert wird verwahrt, eine Spalte " +
      "im neuen Modell gibt es nicht - die Entscheidung steht aus. Das Bedienelement \"Keine " +
      "Kurssicherung\" (frueher Drawer/PaymentTab/ZahlungTab.tsx#fxNoneSetzen: onAendern(id, " +
      "{ fxNone })) schrieb dieses FLACHE Kopffeld; es ist seit Ticket H (2026-10-20) aus dem " +
      "Zahlungs-Reiter entfernt, das Feld hat damit keinen Schreiber mehr",
  ],
  [
    "taskTemplateDescription",
    "OFFENER BEFUND (feldinventar.ts): trotz des Namens keine Vorlagenangabe, sondern das freie " +
      "Notizfeld der Bestellung im Aufgabenbereich (index.html:9142-9145). Es gibt keine Spalte " +
      "dafuer - order_extras.notes selbst ist seit Auftrag D (2026-08-22) entfallen",
  ],
]);

/**
 * RIEGEL 2. Ein Feld, das in keiner Gruppe steht, darf weder stillschweigend in irgendeine Gruppe
 * rutschen noch still verschluckt werden - der Aufruf wirft, BEVOR irgendetwas gesendet wird.
 *
 * Ein LEERES Aenderungsobjekt faellt in dieselbe Klasse: es gibt keine Gruppe her, und das Backend
 * wiese es ohnehin ab (`FELDER_ERFORDERLICH_MELDUNG`, `orders.ts:131-134`). Hier faellt es auf,
 * bevor eine Anfrage hinausgeht.
 */
export class FeldOhneGruppeFehler extends Error {
  readonly felder: readonly string[];

  constructor(felder: readonly string[]) {
    const beschreibung = felder
      .map((feld) => {
        const grund = KEIN_FELDGRUPPEN_WEG.get(feld);
        return grund ? `"${feld}" (${grund})` : `"${feld}"`;
      })
      .join(", ");
    super(
      (felder.length === 0
        ? "bestellungAendern: leeres Aenderungsobjekt - kein Feld, also keine Gruppe. "
        : `bestellungAendern: kein Endpunkt fuer ${beschreibung}. `) +
        "Geschrieben wird ueber PATCH /api/orders/:id/<gruppe>; die Gruppen stehen in " +
        "backend/src/domaene/feldgruppen.ts.",
    );
    this.name = "FeldOhneGruppeFehler";
    this.felder = Object.freeze([...felder]);
  }
}

/**
 * Ein Aufruf trifft EINE Gruppe. Ein Patch ueber zwei Gruppen ist ein Programmierfehler und wirft -
 * NICHT zwei Anfragen hintereinander: die zweite liefe gegen eine bereits erhoehte `rowVersion`
 * (`updateVersioned` erhoeht `order_extras.row_version` bei jedem Schreibvorgang, und alle fuenf
 * Gruppen sitzen auf DERSELBEN Zeile), und beide zusammen waeren nicht zuruecknehmbar, wenn die
 * zweite scheitert. Wer zwei Gruppen schreiben will, ruft zweimal und traegt die Reihenfolge selbst.
 */
export class MehrereGruppenFehler extends Error {
  readonly gruppen: readonly Feldgruppe[];

  constructor(gruppen: readonly Feldgruppe[], felder: readonly string[]) {
    super(
      `bestellungAendern: ${felder.map((f) => `"${f}"`).join(", ")} verteilen sich auf die Gruppen ` +
        `${gruppen.map((g) => `"${g}"`).join(", ")}. Ein Aufruf trifft genau eine Gruppe - ` +
        "zweimal rufen und die Reihenfolge selbst tragen (jeder Aufruf erhoeht die rowVersion).",
    );
    this.name = "MehrereGruppenFehler";
    this.gruppen = Object.freeze([...gruppen]);
  }
}

/**
 * Der PATCH ist bereits verbindlich angekommen, nur der anschliessende Einzelabruf schlug fehl.
 * Die Antwort des PATCH (Feldgruppen-Endpunkt in `bestellungAendern`, seit Fehleranzeige Paket 1 auch
 * `board-status` in `boardStatusAendern`) traegt trotzdem die neue Extras-Version; Aufrufer duerfen
 * sie nicht gegen ihre alte lokale Version eintauschen und den naechsten PATCH damit in einen 409
 * laufen lassen.
 */
export class NachladenNachSchreibenFehler extends Error {
  readonly extrasRowVersion: number | undefined;
  readonly ursache: unknown;

  constructor(id: string, patchAntwort: Record<string, unknown>, ursache: unknown) {
    super(`Bestellung \"${id}\" wurde geschrieben, konnte danach aber nicht frisch geladen werden.`);
    this.name = "NachladenNachSchreibenFehler";
    const rowVersion = patchAntwort.rowVersion;
    this.extrasRowVersion =
      typeof rowVersion === "number" && Number.isInteger(rowVersion) && rowVersion > 0
        ? rowVersion
        : undefined;
    this.ursache = ursache;
  }
}

/**
 * Laedt die Bestellung nach einem Schreibvorgang frisch - siehe Kopfkommentar, "DIE ANTWORT AUF EIN
 * PATCH IST NICHT DIE BESTELLUNG". Faellt der Datensatz zwischen Schreiben und Nachladen weg
 * (Loeschen durch einen anderen Client), wirft das als gewoehnlicher 404 statt `null` zu liefern:
 * die Aufrufer erwarten von `bestellungAendern` einen Datensatz, kein `null`.
 */
async function nachladen(id: string, hintergrund?: boolean): Promise<Order> {
  const neu = await bestellungLaden(id, undefined, hintergrund);
  if (neu === null) {
    throw new ApiFehler(
      404,
      `Die Bestellung "${id}" war nach dem Schreiben nicht mehr vorhanden.`,
      undefined,
    );
  }
  return neu;
}

/**
 * Bestimmt aus einem Aenderungsobjekt die Gruppe und den snake_case-Koerper. Getrennt von
 * `bestellungAendern`, damit beide Riegel ohne Netzzugriff pruefbar sind - und damit die Reihenfolge
 * offensichtlich bleibt: ERST alle Schluessel pruefen, DANN senden. Ein Aufruf mit einem bekannten
 * und einem unbekannten Feld darf gar nichts senden (dieselbe Regel wie `schreibeExtras` im
 * Backend, das ausdruecklich nicht teilweise schreibt).
 */
export function gruppeUndFelder(daten: Partial<Order>): {
  gruppe: Feldgruppe;
  felder: Record<string, unknown>;
} {
  const schluessel = Object.keys(daten);
  if (schluessel.length === 0) {
    throw new FeldOhneGruppeFehler([]);
  }

  const unbekannt = schluessel.filter((feld) => !GRUPPE_JE_FELD.has(feld));
  if (unbekannt.length > 0) {
    throw new FeldOhneGruppeFehler(unbekannt);
  }

  const gruppen = [...new Set(schluessel.map((feld) => GRUPPE_JE_FELD.get(feld)!.gruppe))];
  if (gruppen.length > 1) {
    throw new MehrereGruppenFehler(gruppen, schluessel);
  }

  const felder: Record<string, unknown> = {};
  for (const feld of schluessel) {
    felder[GRUPPE_JE_FELD.get(feld)!.spalte] = (daten as Record<string, unknown>)[feld];
  }
  return { gruppe: gruppen[0]!, felder };
}

/**
 * Aendert Felder EINER Gruppe. Name und Signatur `(id, daten, rowVersion)` sind unveraendert, damit
 * die Aufrufstellen aus den Tasks 3-5 (`App.tsx#drawerAendern`, `App.tsx#boardGruppeAendern`) so
 * bleiben, wie sie sind - nur das Innere hat die Route gewechselt.
 *
 * `async`, nicht "wirft synchron": beide Aufrufstellen haengen ein `.then(...).catch(...)` an das
 * Ergebnis. Ein synchroner Wurf liefe an diesem `.catch` VORBEI und rissse den Ereignisbehandler mit;
 * als abgelehntes Versprechen landet er dort, wo jeder andere Schreibfehler auch landet.
 *
 * `hintergrund`: nur die automatische Archivierung (`useAutoArchivierung`, in `App.tsx` ueber
 * `drawerAendern` angeschlossen) setzt das. Eine solche Archivierung ist nie eine Handlung des
 * Menschen - hat er die Fertigstellung selbst ausgeloest, wurde sein ausloesender PATCH schon
 * gezaehlt -, deshalb gehen ALLE drei Anfragen der Kette (der PATCH und die zwei GETs des Nachladens)
 * als Hintergrundanfragen hinaus (`AnfrageOptionen.hintergrund`, Kopf `x-bestellhub-hintergrund`).
 */
export async function bestellungAendern(
  id: string,
  daten: Partial<Order>,
  rowVersion: number,
  hintergrund?: boolean,
): Promise<Order> {
  const { gruppe, felder } = gruppeUndFelder(daten);
  const patchAntwort = await anfrage<Record<string, unknown>>(`${BASISPFAD}/${encodeURIComponent(id)}/${gruppe}`, {
    methode: "PATCH",
    koerper: { rowVersion, felder },
    hintergrund,
  });
  try {
    return await nachladen(id, hintergrund);
  } catch (fehler) {
    throw new NachladenNachSchreibenFehler(id, patchAntwort, fehler);
  }
}

/**
 * `PATCH /api/orders/:id/board-status` mit `{ rowVersion, status }` (`orders.ts:259-320`) - ANDERE
 * Koerperform als die Feldgruppen (`status`, nicht `felder`), deshalb eine eigene Funktion und kein
 * Sonderzweig in `gruppeUndFelder`.
 *
 * Warum `board_status` keine sechste Feldgruppe ist: jeder Wechsel braucht zusaetzlich einen
 * `order_history`-Eintrag (`setzeBoardStatus`, `backend/src/domaene/extras.ts`), den
 * `feldgruppenHandler`/`schreibeExtras` nicht leisten. In `feldgruppen.ts` steht die Spalte deshalb
 * in `NICHT_SCHREIBBAR`.
 *
 * `boardGroupOverride` ist davon UNBERUEHRT: es liegt in `extras` und geht ueber
 * `bestellungAendern` den gewoehnlichen Weg.
 *
 * AUFRUFER seit dem 2026-08-15: `App.tsx#drawerStatusAendern`, das `onStatus` des Reiters
 * "Bestellung" (`Drawer/MainTab/BestellungTab.tsx`, Abschnitt `main-status`). Bis dahin stand hier
 * "noch kein Aufrufer" - die Funktion war gebaut und getestet, aber keine Flaeche rief sie, und der
 * Status liess sich in der SPA folglich gar nicht setzen.
 *
 * NICHT damit zu verwechseln: das Verschieben einer Zeile zwischen den Board-Gruppen schreibt
 * weiterhin `boardGroupOverride` (`Board/ZeilenUmzug.ts` -> `App.tsx#boardGruppeAendern`) und
 * ruehrt den Status NICHT an - eine Uebersteuerung der Einsortierung, kein fachlicher Wechsel.
 *
 * BERICHTIGT am 2026-08-17: hier stand bis dahin, der Inline-Editor der Bestellliste
 * (`orderListEditorCell`, index.html:7657) sei "weiterhin NICHT portiert" - belegt ueber einen
 * Eintrag `BoardSeite: ["onBearbeiten"]` in der Karte `unverdrahtet` (`test/reference/bundle.test.ts`).
 * Der Portierungsstand war falsch, der damalige Beleg dagegen NICHT: `onBearbeiten` WAR eine Prop
 * von `BoardSeite` (reine Durchreichung an `Bestellzeile`, eingefuehrt mit `f4770db`) und wurde erst
 * am 2026-08-15 mit `637ae8c` planmaessig entfernt und durch `onZelleAendern` ersetzt - der
 * Karteneintrag war zum Zeitpunkt, auf den er sich bezog, richtig und ist mit der Portierung
 * gestrichen worden (`bundle.test.ts:983`: "`BoardSeite` STAND HIER BIS ZUM 2026-08-15 mit
 * `onBearbeiten`"). `Board/Bestellzeile.tsx` fuehrt `onBearbeiten` weiterhin als EIGENE Prop, seither
 * aber intern von `BoardSeite` belegt (`zelleAngeklickt`, siehe unten) statt von aussen durchgereicht.
 *
 * Tatsaechlich IST der Editor seither portiert und muendet in denselben Aufrufer wie der erste Weg
 * oben: der Zellenklick geht an `Board/BoardSeite.tsx#zelleAngeklickt` (prueft `edit_orders` und die
 * Spaltenregel, oeffnet den Editor - meldet noch NICHTS); das Verlassen der Zelle geht an
 * `Board/BoardSeite.tsx#bearbeitungBeenden`, das den uebernommenen Wert ueber die Prop
 * `onZelleAendern` meldet. `App.tsx#boardZelleAendern` wertet `orderListSchreibweg` aus und ruft bei
 * `weg.art === "status"` `App.tsx#drawerStatusAendern` - denselben Aufrufer wie oben -, das hier
 * `boardStatusAendern` aufruft.
 */
export async function boardStatusAendern(
  id: string,
  status: string,
  rowVersion: number,
): Promise<Order> {
  const patchAntwort = await anfrage<Record<string, unknown>>(`${BASISPFAD}/${encodeURIComponent(id)}/board-status`, {
    methode: "PATCH",
    koerper: { rowVersion, status },
  });
  // Wie `bestellungAendern`: der PATCH ist verbindlich angekommen, nur das Nachladen scheiterte (R4, Ruling R-T7a).
  // Der Aufrufer muss das von einer abgelehnten Aenderung unterscheiden koennen - sonst meldet er "konnte nicht
  // geaendert werden", obwohl der Status gesetzt ist, und ein zweiter Versuch liefe in einen 409.
  try {
    return await nachladen(id);
  } catch (fehler) {
    throw new NachladenNachSchreibenFehler(id, patchAntwort, fehler);
  }
}

/**
 * Sammel-Statuswechsel - `PATCH /api/orders/board-status/bulk` (Auftrag "Auf der
 * Bestellübersicht Sammeländerungen für Status und Bereich"; beide Bulk-Routen
 * (`board-status/bulk`, `extras/bulk`) sind seit dem Merge von `feat/bulk-status-bereich` in
 * `main` vorhanden, `backend/src/http/routes/orders.ts`). Dieselbe fachliche Wirkung wie
 * `boardStatusAendern` oben, in EINEM Aufruf fuer mehrere markierte Bestellungen statt eines
 * Aufrufs je Zeile.
 *
 * ANDERS als `boardStatusAendern`: KEIN `nachladen()` je betroffener Id. Bei einer Sammelaktion
 * mit potenziell vielen Eintraegen waere das ein Netzaufruf je Zeile OBEN DRAUF auf den
 * Schreibvorgang selbst - genau der N-fache Umweg, den eine Sammelroute vermeiden soll. Diese
 * Funktion liefert deshalb die ROHANTWORT (`updated`/`conflicts`) UNVERAENDERT zurueck; der
 * Aufrufer (`App.tsx#sammelStatusAendern`) entscheidet selbst, was mit jedem Eintrag geschieht.
 *
 * WICHTIG fuer den Aufrufer: `updated[i]` traegt dieselbe Form wie die Antwort von
 * `PATCH .../board-status` (siehe Kopfkommentar oben, "DIE ANTWORT AUF EIN PATCH IST NICHT DIE
 * BESTELLUNG") - NUR die `order_extras`-Spalten (`orderId`/`rowVersion`/`boardStatus`/...), NICHT
 * die Kopf-/JTL-Felder (`orderNo`/`name`/`items`/...). Ein ungeprueftes `versende({ art:
 * "nachgeladen", datensatz: eintrag })` schriebe denselben Rumpfdatensatz in den Store, den dieser
 * Kopfkommentar fuer den Einzelweg ausdruecklich ausschliesst - siehe die Begruendung dort.
 *
 * Ein Versionskonflikt oder eine inzwischen geloeschte Bestellung bricht den GESAMTEN Aufruf nicht
 * ab (Vertrag des Backends): die uebrigen Eintraege sind trotzdem geschrieben, der betroffene
 * Eintrag steht einzeln in `conflicts`.
 */
export async function boardStatusSammelAendern(
  items: Array<{ id: string; rowVersion: number }>,
  status: string,
): Promise<{ updated: Record<string, unknown>[]; conflicts: Array<{ id: string; reason: string }> }> {
  return anfrage<{ updated: Record<string, unknown>[]; conflicts: Array<{ id: string; reason: string }> }>(
    `${BASISPFAD}/board-status/bulk`,
    { methode: "PATCH", koerper: { items, status } },
  );
}

/**
 * Sammel-Bereichswechsel per Drag-and-Drop (Auftrag "Sammel-Bereichswechsel per Drag-and-Drop",
 * der LETZTE fehlende Teil aus "Auf der Bestellübersicht Sammeländerungen für Status und
 * Bereich") und jede andere Sammelaenderung der `extras`-Gruppe - `PATCH /api/orders/extras/bulk`.
 * Dieselbe fachliche Wirkung wie `bestellungAendern` oben, in EINEM Aufruf fuer mehrere markierte
 * Bestellungen statt eines Aufrufs je Zeile - GENERISCH ueber `daten`, NICHT auf
 * `board_group_override` hartkodiert (konsistent mit dem Einzelweg `bestellungAendern`; das
 * Backend prueft `felder` ohnehin gegen `spaltenDerGruppe("extras")`, siehe
 * `backend/src/http/routes/orders.ts`, Route "/extras/bulk" - ein Schluessel ausserhalb dieser
 * Gruppe lehnt den GESAMTEN Aufruf ab, bevor irgendetwas geschrieben wird).
 *
 * ANDERS als `bestellungAendern`: KEIN `nachladen()` je betroffener Id - dieselbe Begruendung wie
 * an `boardStatusSammelAendern` oben (bei potenziell vielen markierten Zeilen waere das der
 * N-fache Umweg, den eine Sammelroute gerade vermeiden soll). Diese Funktion liefert deshalb die
 * ROHANTWORT (`updated`/`conflicts`) UNVERAENDERT zurueck; der Aufrufer
 * (`App.tsx#boardGruppeSammelAendern`) entscheidet selbst, was mit jedem Eintrag geschieht - GENAU
 * wie bei `boardStatusSammelAendern`/`sammelStatusAendern` oben.
 *
 * Ein Versionskonflikt oder eine inzwischen geloeschte Bestellung bricht den GESAMTEN Aufruf nicht
 * ab (Vertrag des Backends): die uebrigen Eintraege sind trotzdem geschrieben, der betroffene
 * Eintrag steht einzeln in `conflicts`.
 *
 * ================= NACHBESSERUNG (Pruefung 78d5a074, Kritisch, 2026-09-04) =====================
 *
 * HIER STAND BIS DAHIN ein zweiter Parameter `felder: Record<string, unknown>`, den diese Funktion
 * UNUEBERSETZT als `felder` in den Anfragekoerper reichte. `App.tsx#boardGruppeSammelAendern`
 * ruft mit `{ boardGroupOverride: "..." }` - CAMELCASE - auf; die Route prueft jeden Schluessel
 * gegen `spaltenDerGruppe("extras")` (`backend/src/domaene/feldgruppen.ts`), und dort steht
 * `board_group_override` in SNAKE_CASE. Ergebnis: `FeldNichtInGruppeError`, 400, NICHTS wurde
 * geschrieben - bei JEDEM Sammel-Bereichswechsel, kein Randfall. Der Einzelweg
 * (`bestellungAendern` oben) hatte dieses Problem nicht: er schickt sein `daten`-Objekt durch
 * `gruppeUndFelder(...)`, das camelCase auf snake_case abbildet - genau dieser Schritt fehlte
 * hier.
 *
 * DER FIX: `daten` (weiterhin camelCase, wie am Aufrufer) laeuft jetzt GENAU wie am Einzelweg
 * durch `gruppeUndFelder(...)`, BEVOR gesendet wird. `gruppe` wird bewusst NICHT gegen "extras"
 * geprueft: jedes Feld, das diese Funktion heute erreicht (ausschliesslich `boardGroupOverride`),
 * gehoert per Definition zur Gruppe "extras" - ein Feld einer anderen Gruppe waere ein
 * Programmierfehler an der Aufrufstelle, kein Nutzerfehler, den man abfangen und leise schlucken
 * sollte. Wirft `gruppeUndFelder` (leeres `daten`, unbekanntes Feld, mehrere Gruppen), lief das
 * VOR dieser Nachbesserung schon am Einzelweg genauso laut - hier gilt dieselbe Regel.
 */
export async function bestellungSammelAendern(
  items: Array<{ id: string; rowVersion: number }>,
  daten: Partial<Order>,
): Promise<{ updated: Record<string, unknown>[]; conflicts: Array<{ id: string; reason: string }> }> {
  const { felder } = gruppeUndFelder(daten);
  return anfrage<{ updated: Record<string, unknown>[]; conflicts: Array<{ id: string; reason: string }> }>(
    `${BASISPFAD}/extras/bulk`,
    { methode: "PATCH", koerper: { items, felder } },
  );
}
